import { useEffect, useRef, useState } from 'react'

import { Tooltip } from 'components'

import { InfoIcon, TooltipTriangleIcon } from '../icons'
import styles from './InfoTooltip.module.scss'

interface InfoTooltipProps {
  message: string
}

const tooltipStandardLeft = -26
const tooltipRightViewPortMargin = 10
const triangleMargin = 20

const InfoTooltip = ({ message }: InfoTooltipProps) => {
  const [showTooltip, setShowTooltip] = useState(false)
  const [position, setPosition] = useState({ left: tooltipStandardLeft })

  const infoRef = useRef<HTMLDivElement>(null)
  const tooltipRef = useRef<HTMLDivElement>(null)

  const handleMouseEnter = () => setShowTooltip(true)
  const handleMouseLeave = () => setShowTooltip(false)

  useEffect(() => {
    if (showTooltip) {
      if (!tooltipRef.current || !infoRef.current) return

      const tooltipRect = tooltipRef.current.getBoundingClientRect()
      const infoRect = infoRef.current.getBoundingClientRect()
      const viewportWidth = window.innerWidth

      const tooltipRectRight =
        infoRect.left + tooltipRect.width + tooltipStandardLeft + tooltipRightViewPortMargin
      const tooltipRightOverflow = Math.max(0, tooltipRectRight - viewportWidth)

      const left =
        tooltipRightOverflow > 0
          ? tooltipStandardLeft - tooltipRightOverflow - tooltipRightViewPortMargin
          : tooltipStandardLeft

      setPosition({ left })
    }
  }, [showTooltip])

  return (
    <div className={styles.infoTooltip} ref={infoRef}>
      <InfoIcon onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} />
      {showTooltip && (
        <div className={styles.tooltip} ref={tooltipRef} style={{ ...position }}>
          <Tooltip message={message} />
          <TooltipTriangleIcon
            className={styles.tooltipTriangle}
            style={{ marginLeft: triangleMargin - (position.left - tooltipStandardLeft) }}
          />
        </div>
      )}
    </div>
  )
}

export default InfoTooltip
